/*!
 * Collage Beauty — Composition Quiz
 * Shopify install — before </body> in theme.liquid:
 *
 *   {% if request.path == '/pages/composition-quiz' %}
 *     <div id="cb-quiz-embed"></div>
 *     <script>
 *       window.CollageQuizConfig = {
 *         mode: 'embed',
 *         mount: '#cb-quiz-embed',
 *         teaserImage: {{ 'collage-bg.jpg' | asset_url | json }},
 *         teaserImageMobile: {{ 'collage-bg-mobile.jpg' | asset_url | json }},
 *         trackEndpoint: 'https://collage-beauty.vercel.app/api/track',
 *         skipIdentified: false
 *       };
 *     </script>
 *   {% else %}
 *     <script>
 *       window.CollageQuizConfig = {
 *         teaserImage: {{ 'collage-bg.jpg' | asset_url | json }},
 *         teaserImageMobile: {{ 'collage-bg-mobile.jpg' | asset_url | json }},
 *         trackEndpoint: 'https://collage-beauty.vercel.app/api/track'
 *       };
 *     </script>
 *   {% endif %}
 *   <script src="{{ 'cb-quiz.js' | asset_url }}" defer></script>
 *
 * mode: 'popup' (default) — delayed overlay. mode: 'embed' — inline in `mount`.
 * Only one instance boots per page; branch config by path as above.
 */
(function () {
  'use strict';

  if (window.CollageQuiz && window.CollageQuiz.__booted) return;

  /* ------------------------------------------------------------------
     CONFIG
  ------------------------------------------------------------------ */
  var CFG = {
    klaviyoPublicKey : 'R5CxLD',
    klaviyoListId    : 'R2aV94',
    klaviyoRevision  : '2024-10-15',

    codeEndpoint     : null,
    trackEndpoint    : null, // Vercel /api/track — funnel only, never creates Klaviyo profiles
    staticCode       : 'COMPOSITION15',

    offerLine        : '15% off and free shipping on your first order',
    offerShort       : '15% off and free shipping',

    teaserImage      : 'assets/collage-bg.jpg',
    teaserImageMobile: 'assets/collage-bg-mobile.jpg',
    fullSystemUrl    : 'https://collagebeauty.com/collections/the-collage-collection/products/collage-skincare-system',

    delayMs          : 12000,
    scrollPct        : 0, // 0 = disabled; timer is the only trigger
    closeDelayMs     : 0, // ms before the X appears once open; 0 = immediately
    dismissDays      : 30,
    mobileBreakpoint : 720,

    // Skip the quiz for visitors Klaviyo already knows (existing profiles).
    // Requires the Klaviyo onsite snippet (window.klaviyo); fails open if absent.
    skipIdentified       : true,
    identifyCheckWaitMs  : 4000,

    // Empty = all pages. For testing, limit to the news blog index.
    onlyPaths        : [],

    // 'popup' (default) = delayed overlay. 'embed' = inline in `mount`.
    mode             : 'popup',
    mount            : '#cb-quiz-embed',

    // 'auto' | 'desktop' | 'mobile' — demo can override via CollageQuiz.setVariant()
    forceVariant     : 'auto',

    products: {
      canvas          : { name:'Canvas',           handle:'canvas-serum',              variantId:null },
      composition     : { name:'Composition',      handle:'composition-moisturizer',   variantId:null },
      gesso           : { name:'Gesso',            handle:'gesso-balm',                variantId:null },
      starter         : { name:'Starter Set',           handle:'starter-collage-system',    variantId:null },
      complete        : { name:'The Complete Set',      handle:'collage-skincare-system',   variantId:null },
      discovery       : { name:'Collage Discovery Set', handle:'skincare-system-sample-set',variantId:null }
    }
  };

  if (window.CollageQuizConfig) {
    Object.keys(window.CollageQuizConfig).forEach(function (k) {
      if (k === 'products' && window.CollageQuizConfig.products) {
        Object.keys(window.CollageQuizConfig.products).forEach(function (pk) {
          CFG.products[pk] = Object.assign({}, CFG.products[pk], window.CollageQuizConfig.products[pk]);
        });
      } else {
        CFG[k] = window.CollageQuizConfig[k];
      }
    });
  }

  var QUESTIONS = [
    {
      key:'skin_type', headline:'How does your skin usually behave?',
      options:[
        { label:'Dry, tight, never quite enough moisture', value:'dry'         },
        { label:'Shiny by mid-afternoon',                  value:'oily'        },
        { label:'Dull or uneven skin tone',                value:'dull'        },
        { label:'Reactive, flushes easily',                value:'sensitive'   }
      ]
    },
    {
      key:'skin_change', headline:'What\'s your skin doing lately that it wasn\'t before?',
      options:[
        { label:'Firmness fading, fine lines, dull tone', value:'firmness'   },
        { label:'Texture, clogged pores or breakouts',    value:'renewal'    },
        { label:'Redness and reactivity',                 value:'barrier'    },
        { label:'Nothing specific, I want a routine that holds', value:'foundation' }
      ]
    },
    {
      key:'entry_point', headline:'Ready to try Collage?',
      options:[
        { label:'Try it first, see how my skin responds', value:'sample'   },
        { label:'The two essentials',                     value:'starter'  },
        { label:'The complete system',                    value:'complete' }
      ]
    }
  ];

  // skin_change x entry_point → recommendation
  var OUTCOMES = {
    firmness: {
      sample  : { primary:'discovery', secondary:'canvas',      line:'Start with the Discovery Set. Small sizes of all three, so you can find your rhythm before you commit to full size.' },
      starter : { primary:'starter',   secondary:'canvas',      line:'Two essentials to begin. Layer Canvas underneath for firmness and glow.' },
      complete: { primary:'complete',  secondary:null,          line:'Three steps. Hydrate, renew, strengthen — built for lasting firmness.' }
    },
    renewal: {
      sample  : { primary:'discovery', secondary:'composition', line:'Start with the Discovery Set. Small sizes of all three, so you can see how your skin responds first.' },
      starter : { primary:'starter',   secondary:'composition', line:'Two essentials. Composition on top to renew texture gently.' },
      complete: { primary:'complete',  secondary:null,          line:'Three steps. Hydrate, renew, strengthen — for clearer, calmer skin.' }
    },
    barrier: {
      sample  : { primary:'discovery', secondary:'gesso',       line:'Start with the Discovery Set. Small sizes of all three, so you can introduce one layer at a time.' },
      starter : { primary:'starter',   secondary:'gesso',       line:'Two essentials, with Gesso to calm and seal reactive skin.' },
      complete: { primary:'complete',  secondary:null,          line:'Three steps. Hydrate, renew, strengthen — with barrier support built in.' }
    },
    foundation: {
      sample  : { primary:'discovery', secondary:null,          line:'Start with the Discovery Set. Small sizes of all three, so you can find the routine that holds.' },
      starter : { primary:'starter',   secondary:null,          line:'Two essentials. Canvas and Composition, morning and night.' },
      complete: { primary:'complete',  secondary:null,          line:'Three steps. Hydrate, renew, strengthen — a routine that holds.' }
    }
  };

  var HAS_GESSO = { gesso:1, complete:1, discovery:1 };

  /* ------------------------------------------------------------------
     STYLES — desktop = centered split card, mobile = bottom sheet
  ------------------------------------------------------------------ */
  var CSS = [
'@font-face{font-family:\'Enduro\';src:url(\'https://collagebeauty.com/cdn/shop/files/EnduroWeb-Regular.woff2?v=1728090289\') format(\'woff2\');font-weight:400;font-style:normal;font-display:swap}',
'@font-face{font-family:\'Enduro\';src:url(\'https://collagebeauty.com/cdn/shop/files/EnduroWeb-Medium.woff2?v=1728090289\') format(\'woff2\');font-weight:500;font-style:normal;font-display:swap}',
'@font-face{font-family:\'Enduro\';src:url(\'https://collagebeauty.com/cdn/shop/files/EnduroWeb-Bold.woff2?v=1728090289\') format(\'woff2\');font-weight:700;font-style:normal;font-display:swap}',
'@font-face{font-family:\'Harmonique Display\';src:url(\'https://collagebeauty.com/cdn/shop/files/HarmoniqueDisplay-Regular.woff2?v=1728941300\') format(\'woff2\');font-weight:400;font-style:normal;font-display:swap}',
'#cb-quiz-root{--cb-bg:#F5F0ED;--cb-ink:#040707;--cb-muted:rgba(4,7,7,.58);--cb-line:#d8d4cd;--cb-accent:#050707;--cb-on-accent:#ffffff;--cb-border:#040707;--cb-soft:#ebe4df;--cb-shimmer:#172627;--cb-display:\'Enduro\',system-ui,-apple-system,\'Segoe UI\',Roboto,Arial,sans-serif;--cb-accent-font:\'Harmonique Display\',Georgia,serif;--cb-body:\'Enduro\',system-ui,-apple-system,\'Segoe UI\',Roboto,Arial,sans-serif;--cb-shadow:rgba(0,0,0,.15) 0 0 30px 0}',
'#cb-quiz-root{position:fixed;inset:0;z-index:2147483000;background:rgba(4,7,7,.45);display:flex;opacity:0;pointer-events:none;transition:opacity .28s ease}',
'#cb-quiz-root.cb-open{opacity:1;pointer-events:auto}',
'#cb-quiz-root[data-variant="desktop"]{align-items:center;justify-content:center;padding:32px}',
'#cb-quiz-root[data-variant="mobile"]{align-items:stretch;justify-content:stretch;padding:0}',
'.cb-modal{position:relative;background:var(--cb-bg);color:var(--cb-ink);font-family:var(--cb-body);border:1px solid var(--cb-line);box-shadow:var(--cb-shadow);overflow:hidden;display:flex;flex-direction:column}',
'#cb-quiz-root[data-variant="desktop"] .cb-modal{width:min(1080px,92vw);height:75vh;max-height:75vh;border-radius:8px;flex-direction:row;transform:translateY(14px) scale(.985);transition:transform .3s cubic-bezier(.22,1,.36,1)}',
'#cb-quiz-root[data-variant="desktop"].cb-open .cb-modal{transform:none}',
'#cb-quiz-root[data-variant="mobile"] .cb-modal{width:100%;height:100%;max-height:100dvh;min-height:100%;border-radius:0;border:0;transform:translateY(12px);opacity:0;transition:transform .34s cubic-bezier(.22,1,.36,1),opacity .28s ease}',
'#cb-quiz-root[data-variant="mobile"].cb-open .cb-modal{transform:none;opacity:1}',
'.cb-modal__media{display:none;position:relative;background:var(--cb-soft);overflow:hidden}',
'#cb-quiz-root[data-variant="desktop"] .cb-modal__media{display:block;flex:0 0 42%;min-height:100%;align-self:stretch}',
'.cb-modal__media img,.cb-modal__media .cb-still-fill{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;display:block}',
'.cb-still-fill{background:linear-gradient(160deg,rgba(23,39,39,.35),rgba(243,241,238,.2)),linear-gradient(150deg,#e8e5e0,#f3f1ee 55%,#ddd9d2)}',
'.cb-modal__body{position:relative;display:flex;flex-direction:column;min-width:0;flex:1;min-height:0;transform:translateZ(0)}',
'#cb-quiz-root[data-variant="desktop"] .cb-modal__body{height:100%;max-height:none}',
'#cb-quiz-root[data-variant="mobile"] .cb-modal__body{height:100%;padding-top:env(safe-area-inset-top,0px);padding-bottom:env(safe-area-inset-bottom,0px)}',
'.cb-handle{display:none}',
'.cb-brand{display:none}',
'.cb-teaser-logo{display:block;width:120px;height:auto;margin:0 0 20px}',
'#cb-quiz-root[data-variant="mobile"] .cb-teaser-logo{margin-left:auto;margin-right:auto}',
'.cb-progress{display:flex;gap:4px;padding:0;height:2px;background:transparent;flex-shrink:0}',
'.cb-progress i{flex:1;height:2px;background:var(--cb-line);transition:background .4s ease}',
'.cb-progress i.cb-filled{background:var(--cb-accent)}',
'.cb-close{position:absolute;top:12px;right:12px;z-index:5;width:40px;height:40px;padding:0;background:transparent;border:0;cursor:pointer;color:var(--cb-muted);line-height:1;font-size:24px;opacity:0;visibility:hidden;pointer-events:none;transition:opacity .3s ease,color .18s ease;transform:translateZ(0)}',
'.cb-close.cb-close-show{opacity:1;visibility:visible;pointer-events:auto}',
'@media (hover:hover){.cb-close:hover{color:var(--cb-ink)}}',
'#cb-quiz-root[data-variant="mobile"] .cb-close{top:calc(8px + env(safe-area-inset-top,0px));right:8px}',
'#cb-quiz-root[data-variant="desktop"] .cb-close{color:rgba(4,7,7,.45)}',
'@media (hover:hover){#cb-quiz-root[data-variant="desktop"] .cb-close:hover{color:var(--cb-ink)}}',
'.cb-pane{padding:40px;overflow:auto;-webkit-overflow-scrolling:touch;flex:1;min-height:0;display:flex;flex-direction:column}',
'#cb-quiz-root[data-variant="mobile"] .cb-pane{padding:32px 24px 28px}',
'#cb-quiz-root[data-variant="mobile"] .cb-pane--capture{padding-bottom:320px;padding-bottom:min(42dvh,360px)}',
'.cb-pane__inner{width:100%;margin-top:auto;margin-bottom:auto}',
'.cb-anim{animation:cb-rise .24s ease both}',
'@keyframes cb-rise{from{opacity:0;transform:translateY(8px)}to{opacity:1;transform:none}}',
'.cb-fade{opacity:0;animation:cb-fade-in .55s cubic-bezier(.22,1,.36,1) calc(var(--cb-d, 0) * .18s + .06s) forwards}',
'.cb-fade-1{--cb-d:0}',
'.cb-fade-2{--cb-d:1}',
'.cb-fade-3{--cb-d:2}',
'.cb-fade-4{--cb-d:3}',
'.cb-fade-5{--cb-d:4}',
'.cb-fade-6{--cb-d:5}',
'.cb-fade-7{--cb-d:6}',
'@keyframes cb-fade-in{from{opacity:0;transform:translate3d(0,14px,0)}to{opacity:1;transform:translate3d(0,0,0)}}',
'.cb-eyebrow{font-family:var(--cb-body);font-weight:500;font-size:13px;line-height:1;letter-spacing:.09em;text-transform:uppercase;color:var(--cb-muted);margin:0 0 16px}',
'.cb-kicker{font-family:var(--cb-body);font-weight:500;font-size:18px;line-height:24px;letter-spacing:.02em;color:var(--cb-muted);margin:0 0 12px}',
'.cb-h{font-family:var(--cb-display);font-weight:700;font-size:35px;line-height:42px;letter-spacing:0;margin:0 0 16px;color:var(--cb-ink)}',
'.cb-h em{font-family:var(--cb-accent-font);font-weight:400;font-style:normal;font-size:29px;line-height:42px;letter-spacing:-.4375px}',
'.cb-sub{font-family:var(--cb-accent-font);font-weight:400;font-size:19px;line-height:28px;color:var(--cb-muted);margin:0 0 24px}',
'.cb-p{font-size:16px;line-height:24px;margin:0 0 16px;color:var(--cb-ink)}',
'.cb-fine{font-size:13px;line-height:19px;color:var(--cb-muted);margin:0}',
'.cb-still-mobile{width:100%;height:auto;aspect-ratio:auto;margin:0 0 24px;object-fit:contain;object-position:center;display:block;border:0;background:transparent}',
'#cb-quiz-root[data-variant="desktop"] .cb-still-mobile{display:none}',
'#cb-quiz-root[data-variant="mobile"] .cb-still-mobile{width:calc(100% + 40px);max-width:none;margin-left:-20px;margin-right:-20px;margin-bottom:24px}',
'.cb-opts{display:flex;flex-direction:column;gap:8px;margin:0 0 8px}',
'.cb-opt{width:100%;text-align:left;cursor:pointer;font-family:var(--cb-body);font-size:16px;line-height:24px;color:var(--cb-ink);background:transparent;border:1px solid var(--cb-line);border-radius:0;padding:16px 18px;transition:border-color .18s ease,background .18s ease}',
'@media (hover:hover){.cb-opt:hover{border-color:var(--cb-accent);background:rgba(5,7,7,.04)}}',
'.cb-btn{box-sizing:border-box;display:inline-block;position:relative;overflow:hidden;isolation:isolate;font-family:var(--cb-body);font-weight:500;font-size:14px;letter-spacing:.06em;text-transform:uppercase;text-decoration:none;background:transparent;color:var(--cb-on-accent);border:1px solid var(--cb-border);border-radius:0;cursor:pointer;min-width:220px;min-height:52px;padding:14px 24px;line-height:20px;transition:color .25s ease,border-color .25s ease,transform .12s ease}',
'.cb-btn::before{content:"";position:absolute;inset:0;z-index:-1;background-color:var(--cb-accent);background-image:linear-gradient(105deg,transparent 0%,transparent 42%,var(--cb-shimmer) 50%,rgba(255,255,255,.14) 52%,var(--cb-shimmer) 54%,transparent 62%,transparent 100%);background-size:250% 100%;background-repeat:no-repeat;background-position:140% 0;transition:background-position .75s cubic-bezier(.22,1,.36,1),background-color .4s ease}',
'@media (hover:hover){.cb-btn:hover::before{background-color:var(--cb-shimmer);background-position:-40% 0}}',
'.cb-btn:active{transform:scale(.98)}',
'.cb-btn[disabled]{opacity:.4;cursor:default;transform:none}',
'@media (hover:hover){.cb-btn[disabled]:hover::before{background-color:var(--cb-accent);background-position:140% 0}}',
'.cb-btn.cb-wide{width:100%;min-width:0}',
'.cb-btn.cb-ghost{color:var(--cb-ink);border-color:var(--cb-border)}',
'.cb-btn.cb-ghost::before{background-color:transparent;background-image:linear-gradient(105deg,transparent 0%,transparent 42%,var(--cb-shimmer) 50%,rgba(255,255,255,.14) 52%,var(--cb-shimmer) 54%,transparent 62%,transparent 100%);background-size:250% 100%;background-repeat:no-repeat;background-position:140% 0}',
'@media (hover:hover){.cb-btn.cb-ghost:hover{color:var(--cb-on-accent)}.cb-btn.cb-ghost:hover::before{background-color:var(--cb-shimmer);background-position:-40% 0}}',
'.cb-actions{display:flex;flex-direction:row;flex-wrap:wrap;align-items:center;justify-content:flex-start;gap:12px;margin-top:24px}',
'.cb-actions .cb-btn{width:auto}',
'#cb-quiz-root[data-variant="mobile"] .cb-btn.cb-wide{width:100%;min-width:0}',
'#cb-quiz-root[data-variant="mobile"] .cb-actions .cb-btn{flex:1 1 auto;min-width:0}',
'.cb-textlink{display:inline-block;background:none;border:0;padding:0;cursor:pointer;font-family:var(--cb-body);font-size:13px;font-weight:400;line-height:19px;color:var(--cb-muted);text-decoration:underline;text-underline-offset:3px}',
'@media (hover:hover){.cb-textlink:hover{color:var(--cb-ink);opacity:1}}',
'.cb-back{margin:0 0 20px}',
'.cb-foot{margin-top:24px;text-align:center}',
'.cb-field{position:relative;margin:0 0 16px}',
'.cb-field input{width:100%;box-sizing:border-box;font-family:var(--cb-body);font-size:16px;line-height:24px;color:var(--cb-ink);background:transparent;border:0;border-bottom:1px solid var(--cb-line);border-radius:0;padding:10px 0}',
'.cb-field input:focus{outline:0;border-bottom-color:var(--cb-accent)}',
'.cb-field input::placeholder{color:rgba(4,7,7,.38)}',
'.cb-err{font-size:13px;line-height:19px;color:#8a3d2f;margin:8px 0 0;min-height:19px}',
'.cb-result-card{background:var(--cb-soft);color:var(--cb-ink);border:1px solid var(--cb-line);border-radius:8px;padding:16px;margin:0 0 24px}',
'.cb-result-card .cb-eyebrow{color:var(--cb-muted);margin-bottom:8px}',
'.cb-code{font-family:var(--cb-display);font-weight:700;font-size:29px;line-height:36px;letter-spacing:.06em;margin:0 0 8px}',
'.cb-code-note{font-size:13px;line-height:19px;color:var(--cb-muted);margin:0}',
'.cb-pill{display:inline-block;font-size:13px;line-height:19px;color:var(--cb-ink);border:1px solid var(--cb-line);padding:4px 10px;margin:0 0 16px}',
'.cb-spin{display:inline-block;width:13px;height:13px;border:2px solid rgba(255,255,255,.28);border-top-color:var(--cb-on-accent);border-radius:50%;animation:cb-turn .7s linear infinite;vertical-align:-2px}',
'@keyframes cb-turn{to{transform:rotate(360deg)}}',
'#cb-quiz-root :focus-visible{outline:2px solid var(--cb-accent);outline-offset:2px}',
'#cb-quiz-root[data-variant="desktop"] .cb-h{font-size:32px;line-height:38px}',
'#cb-quiz-root[data-variant="desktop"] .cb-h em{font-size:27px;line-height:38px}',
'#cb-quiz-root[data-variant="mobile"] .cb-h{font-size:27px;line-height:34px}',
'#cb-quiz-root[data-variant="mobile"] .cb-h em{font-size:24px;line-height:34px}',
'#cb-quiz-root[data-variant="mobile"] .cb-sub{font-size:17px;line-height:26px}',
/* Embed mode — only when data-mode="embed"; popup styles above stay untouched */
'#cb-quiz-root[data-mode="embed"]{position:relative;inset:auto;left:auto;z-index:auto;background:transparent;display:flex;opacity:1;pointer-events:auto;align-items:stretch;justify-content:stretch;min-height:0;width:min(1120px,calc(100vw - 48px));max-width:none;margin:0;padding:0;box-sizing:border-box}',
'#cb-quiz-root[data-mode="embed"] .cb-modal{width:100%;max-width:none;margin:0;transform:none;opacity:1;box-shadow:none}',
'#cb-quiz-root[data-mode="embed"][data-variant="desktop"] .cb-modal{width:100%;height:min(70vh,640px);max-height:none;min-height:560px;border-radius:8px;flex-direction:row}',
'#cb-quiz-root[data-mode="embed"][data-variant="mobile"] .cb-modal{width:100%;height:auto;max-height:none;min-height:0;border-radius:8px;border:1px solid var(--cb-line);flex-direction:column}',
'#cb-quiz-root[data-mode="embed"][data-variant="mobile"]{width:100%;margin-left:0!important}',
'#cb-quiz-root[data-mode="embed"][data-variant="mobile"] .cb-modal__body{height:auto;padding-top:0;padding-bottom:0}',
'#cb-quiz-root[data-mode="embed"][data-variant="mobile"] .cb-pane{min-height:420px}',
'#cb-quiz-root[data-mode="embed"][data-variant="mobile"] .cb-pane--capture{padding-bottom:28px}',
'#cb-quiz-root[data-mode="embed"] .cb-close{display:none!important}',
'@media (prefers-reduced-motion:reduce){#cb-quiz-root,.cb-modal,.cb-anim,.cb-fade,.cb-spin{transition:none!important;animation:none!important;opacity:1!important;transform:none!important}#cb-quiz-root[data-variant="desktop"] .cb-modal,#cb-quiz-root[data-variant="mobile"] .cb-modal{transform:none}.cb-btn::before{background-image:none!important;transition:background-color .2s ease!important}}',
'@media (prefers-reduced-motion:reduce) and (hover:hover){.cb-btn:hover::before{background-color:var(--cb-shimmer)}}'
  ].join('');

  function injectStyles() {
    if (document.getElementById('cb-quiz-styles')) return;
    var s = document.createElement('style');
    s.id = 'cb-quiz-styles';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  /* ------------------------------------------------------------------
     HELPERS
  ------------------------------------------------------------------ */
  function resolve(a) {
    var base = OUTCOMES[a.skin_change][a.entry_point];
    var out = { primary:base.primary, secondary:base.secondary, line:base.line, sensitive:false };
    if (a.skin_type === 'sensitive' && !HAS_GESSO[out.primary] && out.secondary !== 'gesso') {
      if (out.primary === 'starter') {
        out.primary = 'complete';
        out.secondary = null;
        out.line = 'Three steps. Hydrate, renew, strengthen, with Gesso to calm reactive skin.';
      } else {
        out.secondary = 'gesso';
      }
      out.sensitive = true;
    }
    return out;
  }

  function compositionName(out) {
    var p = CFG.products[out.primary].name;
    if (!out.secondary || out.primary === 'complete') return p;
    if (out.primary === 'discovery' || out.primary === 'starter') return p;
    return p + ' + ' + CFG.products[out.secondary].name;
  }

  var mem = {};
  var store = {
    get: function (k) { try { return window.localStorage.getItem(k); } catch (e) { return mem[k] || null; } },
    set: function (k, v) { try { window.localStorage.setItem(k, v); } catch (e) { mem[k] = v; } },
    del: function (k) { try { window.localStorage.removeItem(k); } catch (e) { delete mem[k]; } }
  };

  var K_DISMISS = 'cb_quiz_dismissed_at';
  var K_DONE = 'cb_quiz_completed';

  function suppressed() {
    if (store.get(K_DONE)) return true;
    if (store.get('cb_subscribed')) return true;
    var d = parseInt(store.get(K_DISMISS) || '0', 10);
    if (d && (Date.now() - d) < CFG.dismissDays * 864e5) return true;
    return false;
  }

  function activeVariant() {
    if (CFG.forceVariant === 'desktop' || CFG.forceVariant === 'mobile') return CFG.forceVariant;
    return window.matchMedia('(max-width:' + (CFG.mobileBreakpoint - 1) + 'px)').matches ? 'mobile' : 'desktop';
  }

  function isEmbed() {
    return CFG.mode === 'embed';
  }

  function resolveMount() {
    if (!isEmbed()) return document.body;
    var sel = CFG.mount || '#cb-quiz-embed';
    if (sel && sel.nodeType === 1) return sel;
    return document.querySelector(sel);
  }

  // Center the embed in the viewport. Shopify page templates are often a
  // left-aligned narrow column, so %/vw CSS alone cannot center reliably.
  function centerEmbed() {
    if (!isEmbed() || !scrim) return;
    if (variant === 'mobile') {
      scrim.style.marginLeft = '';
      return;
    }
    scrim.style.marginLeft = '0px';
    var rect = scrim.getBoundingClientRect();
    var target = Math.max(24, (window.innerWidth - rect.width) / 2);
    scrim.style.marginLeft = Math.round(target - rect.left) + 'px';
  }

  /* ------------------------------------------------------------------
     STATE + DOM
  ------------------------------------------------------------------ */
  var answers = {}, step = 0, result = null, code = null, lastFocus = null, currentStepRender = null;
  var scrim, modal, media, pane, bars, closeBtn, closeTimer, variant = 'desktop';

  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html != null) n.innerHTML = html;
    return n;
  }

  function paintMedia() {
    if (!media) return;
    media.setAttribute('aria-hidden', variant === 'desktop' ? 'false' : 'true');
    var src = CFG.teaserImage || '';
    if (media.getAttribute('data-ready') === src && media.querySelector('img, .cb-still-fill')) return;
    media.setAttribute('data-ready', src);
    if (src) {
      media.innerHTML = '<img src="' + src + '" alt="">';
    } else {
      media.innerHTML = '<div class="cb-still-fill" role="presentation"></div>';
    }
  }

  function mobileStillHtml() {
    var src = CFG.teaserImageMobile || CFG.teaserImage;
    if (src) {
      return '<img class="cb-still-mobile" src="' + src + '" alt="">';
    }
    return '<div class="cb-still-mobile" role="presentation" style="background:linear-gradient(150deg,#e8e5e0,#f3f1ee)"></div>';
  }

  function applyVariant(next) {
    var resolved = next || activeVariant();
    var changed = resolved !== variant;
    var needsMedia = !media || !media.getAttribute('data-ready');
    variant = resolved;
    if (!scrim) return;
    scrim.setAttribute('data-variant', variant);
    if (changed || needsMedia) paintMedia();
    // Only rebuild step markup when the layout variant actually changes
    if (changed && currentStepRender) currentStepRender();
    if (isEmbed()) centerEmbed();
  }

  function build() {
    if (document.getElementById('cb-quiz-root')) {
      scrim = document.getElementById('cb-quiz-root');
      modal = scrim.querySelector('.cb-modal');
      media = scrim.querySelector('.cb-modal__media');
      pane = scrim.querySelector('.cb-pane');
      bars = scrim.querySelector('.cb-progress');
      closeBtn = scrim.querySelector('.cb-close');
      return true;
    }

    var mountEl = resolveMount();
    if (!mountEl) {
      if (typeof console !== 'undefined' && console.warn) {
        console.warn('[CollageQuiz] embed mount not found:', CFG.mount || '#cb-quiz-embed');
      }
      return false;
    }

    scrim = el('div');
    scrim.id = 'cb-quiz-root';
    scrim.setAttribute('data-mode', isEmbed() ? 'embed' : 'popup');
    if (isEmbed()) {
      scrim.setAttribute('role', 'region');
      scrim.setAttribute('aria-label', 'Find your personalized skincare');
    } else {
      scrim.setAttribute('role', 'dialog');
      scrim.setAttribute('aria-modal', 'true');
      scrim.setAttribute('aria-label', 'Find your personalized skincare');
    }

    modal = el('div', 'cb-modal');
    media = el('div', 'cb-modal__media');
    media.setAttribute('aria-hidden', 'true');

    var body = el('div', 'cb-modal__body');

    bars = el('div', 'cb-progress');
    for (var i = 0; i < 3; i++) bars.appendChild(el('i'));

    closeBtn = el('button', 'cb-close', '&times;');
    closeBtn.type = 'button';
    closeBtn.setAttribute('aria-label', 'Close');
    closeBtn.setAttribute('tabindex', '-1');
    closeBtn.addEventListener('click', function () { dismiss(); });

    pane = el('div', 'cb-pane');

    body.appendChild(bars);
    body.appendChild(pane);
    modal.appendChild(media);
    modal.appendChild(body);
    // Keep close outside the animated body so showing it cannot restart step fades
    modal.appendChild(closeBtn);
    scrim.appendChild(modal);
    mountEl.appendChild(scrim);

    document.addEventListener('keydown', function (e) {
      if (!scrim.classList.contains('cb-open')) return;
      if (isEmbed()) return; // page content — no focus trap
      if (e.key === 'Tab') trap(e);
    });

    window.addEventListener('resize', function () {
      if (isEmbed()) centerEmbed();
      if (CFG.forceVariant !== 'auto') return;
      var next = activeVariant();
      if (next !== variant) applyVariant(next);
    });

    applyVariant();
    return true;
  }

  function scheduleCloseBtn() {
    if (closeTimer) clearTimeout(closeTimer);
    if (!closeBtn || isEmbed()) return;
    function show() {
      if (!scrim || !scrim.classList.contains('cb-open')) return;
      closeBtn.classList.add('cb-close-show');
      closeBtn.setAttribute('tabindex', '0');
    }
    var delay = Number(CFG.closeDelayMs) || 0;
    if (delay <= 0) { show(); return; }
    closeBtn.classList.remove('cb-close-show');
    closeBtn.setAttribute('tabindex', '-1');
    closeTimer = setTimeout(show, delay);
  }

  function trap(e) {
    var nodes = modal.querySelectorAll('button, input, a[href]');
    var f = [];
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].classList.contains('cb-close') && !nodes[i].classList.contains('cb-close-show')) continue;
      f.push(nodes[i]);
    }
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function paint(html, opts) {
    pane.className = 'cb-pane' + (opts && opts.stagger ? '' : ' cb-anim');
    pane.innerHTML = '<div class="cb-pane__inner">' + html + '</div>';
    void pane.offsetWidth;
    pane.scrollTop = 0;
    if (opts && opts.focusSelector) {
      var f = pane.querySelector(opts.focusSelector);
      if (f) f.focus({ preventScroll: true });
    }
  }

  function progress(n) {
    var kids = bars.children;
    for (var i = 0; i < kids.length; i++) kids[i].classList.toggle('cb-filled', i < n);
  }

  /* ------------------------------------------------------------------
     STEPS
  ------------------------------------------------------------------ */
  function renderTeaser() {
    currentStepRender = renderTeaser;
    step = 0;
    progress(0);

    var still = variant === 'mobile' ? mobileStillHtml() : '';

    paint(
      '<div class="cb-teaser">' +
        '<img class="cb-teaser-logo" src="https://collagebeauty.com/cdn/shop/files/collage-logo-default.svg?v=1728939871&width=160" alt="Collage Beauty" width="160" height="27">' +
        still +
        '<p class="cb-kicker cb-fade cb-fade-1">Find Your Personalized Skincare</p>' +
        '<h2 class="cb-h cb-fade cb-fade-2">Claim Free Shipping &amp; 15% Off</h2>' +
        '<div class="cb-actions cb-fade cb-fade-3">' +
          '<button type="button" class="cb-btn" data-act="start">Start Quiz</button>' +
        '</div>' +
      '</div>',
      { stagger: true }
    );

    pane.querySelector('[data-act="start"]').addEventListener('click', function () {
      funnelTrack('started');
      renderQuestion(0);
    });
  }

  function renderQuestion(i) {
    currentStepRender = function () { renderQuestion(i); };
    step = i + 1;
    progress(i);
    var q = QUESTIONS[i];
    var delayBase = i > 0 ? 1 : 0;

    var opts = q.options.map(function (o, idx) {
      var fadeN = Math.min(delayBase + 2 + idx, 7);
      return '<button type="button" class="cb-opt cb-fade cb-fade-' + fadeN + '" role="radio" aria-pressed="false" data-v="' + o.value + '">' + o.label + '</button>';
    }).join('');

    paint(
      (i > 0 ? '<div class="cb-back cb-fade cb-fade-1"><button type="button" class="cb-textlink" data-act="back">Back</button></div>' : '') +
      '<h2 class="cb-h cb-fade cb-fade-' + (delayBase + 1) + '">' + q.headline + '</h2>' +
      '<div class="cb-opts" role="radiogroup" aria-label="' + q.headline + '">' + opts + '</div>',
      { stagger: true }
    );

    Array.prototype.forEach.call(pane.querySelectorAll('.cb-opt'), function (b) {
      b.addEventListener('click', function () {
        answers[q.key] = b.getAttribute('data-v');
        if (i < QUESTIONS.length - 1) renderQuestion(i + 1);
        else renderCapture();
      });
    });

    var back = pane.querySelector('[data-act="back"]');
    if (back) back.addEventListener('click', function () { renderQuestion(i - 1); });
  }

  function renderCapture() {
    currentStepRender = renderCapture;
    step = 4;
    progress(3);

    paint(
      '<div class="cb-back cb-fade cb-fade-1"><button type="button" class="cb-textlink" data-act="back">Back</button></div>' +
      '<h2 class="cb-h cb-fade cb-fade-2">Your recommendation is ready.</h2>' +
      '<p class="cb-sub cb-fade cb-fade-3">Enter your email to see your routine, plus ' + CFG.offerLine + '.</p>' +
      '<div class="cb-field cb-fade cb-fade-4">' +
        '<label for="cb-email" style="position:absolute;left:-9999px">Email address</label>' +
        '<input id="cb-email" type="email" inputmode="email" autocomplete="email" placeholder="you@email.com">' +
      '</div>' +
      '<p class="cb-err" id="cb-err" role="alert"></p>' +
      '<button type="button" class="cb-btn cb-wide cb-fade cb-fade-5" data-act="submit">See my routine</button>' +
      '<p class="cb-fine cb-fade cb-fade-6" style="margin-top:16px">Unsubscribe at any time.</p>',
      { stagger: true, focusSelector: '#cb-email' }
    );

    // Mobile: reserve room below the fields so the on-screen keyboard
    // doesn't cover the input, then nudge it into view once the keyboard
    // has started animating in.
    pane.classList.add('cb-pane--capture');

    var input = pane.querySelector('#cb-email');
    var err = pane.querySelector('#cb-err');
    var btn = pane.querySelector('[data-act="submit"]');

    if (variant === 'mobile') {
      setTimeout(function () {
        if (pane.contains(input) && document.activeElement === input) {
          input.scrollIntoView({ block: 'center', behavior: 'smooth' });
        }
      }, 150);
    }

    pane.querySelector('[data-act="back"]').addEventListener('click', function () { renderQuestion(2); });
    input.addEventListener('keydown', function (e) { if (e.key === 'Enter') btn.click(); });
    input.addEventListener('input', function () { err.textContent = ''; });

    btn.addEventListener('click', function () {
      var v = (input.value || '').trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)) {
        err.textContent = 'Enter a valid email address to see your routine.';
        input.focus();
        return;
      }
      btn.disabled = true;
      btn.innerHTML = '<span class="cb-spin"></span>';
      submit(v).then(renderResults).catch(function () { renderResults(); });
    });
  }

  function renderResults() {
    currentStepRender = renderResults;
    step = 5;
    progress(3);
    result = result || resolve(answers);
    var name = compositionName(result);
    var d = 1;

    paint(
      '<p class="cb-eyebrow cb-fade cb-fade-' + (d++) + '">Your Skincare Solution</p>' +
      '<h2 class="cb-h cb-fade cb-fade-' + (d++) + '">' + name + '</h2>' +
      (result.sensitive ? '<p class="cb-pill cb-fade cb-fade-' + (d++) + '">Gesso added for reactive skin</p>' : '') +
      '<p class="cb-p cb-fade cb-fade-' + (d++) + '">' + result.line + '</p>' +
      '<div class="cb-result-card cb-fade cb-fade-' + (d++) + '">' +
        '<p class="cb-code-note">Your code for ' + CFG.offerShort + ' is on its way — check your email.</p>' +
      '</div>' +
      '<button type="button" class="cb-btn cb-wide cb-fade cb-fade-' + (d++) + '" data-act="cart">Shop Your Match</button>' +
      '<div class="cb-foot cb-fade cb-fade-' + Math.min(d, 7) + '"><a class="cb-textlink" href="' + CFG.fullSystemUrl + '">See the full system</a></div>',
      { stagger: true }
    );

    pane.querySelector('[data-act="cart"]').addEventListener('click', function () {
      var rec = CFG.products[result.primary].handle;
      funnelTrack('clicked_recommendation', { recommendation: rec });
      track('Clicked Quiz Recommendation', { recommendation: rec });
      window.location.href = cartUrl(result);
    });
  }

  function cartUrl(out) {
    var p = CFG.products[out.primary];
    if (p.variantId) return 'https://collagebeauty.com/cart/' + p.variantId + ':1';
    return 'https://collagebeauty.com/collections/the-collage-collection/products/' + p.handle;
  }

  /* ------------------------------------------------------------------
     KLAVIYO
  ------------------------------------------------------------------ */
  function kl(path, body) {
    return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(CFG.klaviyoPublicKey), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/vnd.api+json',
        'Accept': 'application/vnd.api+json',
        'revision': CFG.klaviyoRevision
      },
      body: JSON.stringify(body)
    }).then(function (res) {
      if (!res.ok && res.status !== 202) {
        return res.text().then(function (t) {
          throw new Error('Klaviyo ' + path + ' failed: ' + res.status + ' ' + t);
        });
      }
      return res;
    });
  }

  var submitIp = null; // set from /api/track on submitted, sent to Klaviyo

  function props() {
    var p = {
      skin_type: answers.skin_type,
      skin_change: answers.skin_change,
      entry_point: answers.entry_point,
      quiz_recommendation: CFG.products[result.primary].handle,
      quiz_completed_at: new Date().toISOString(),
      quiz_variant: variant
    };
    if (submitIp) p.quiz_submit_ip = submitIp;
    return p;
  }

  // Profile attributes for the Klaviyo upsert/subscribe: identifiers +
  // properties, plus location.ip when the track endpoint returned one.
  function profileAttrs(email) {
    var a = Object.assign(profileIdentifiers(email), { properties: props() });
    if (submitIp) a.location = { ip: submitIp };
    return a;
  }

  function anonId() {
    var id = store.get('cb_anon');
    if (!id) { id = 'cb_' + Math.random().toString(36).slice(2) + Date.now().toString(36); store.set('cb_anon', id); }
    return id;
  }

  // Resolves to the parsed JSON response ({ ip } on submitted) or null.
  // Never rejects — funnel logging must not affect the quiz.
  function funnelTrack(event, extra) {
    if (!CFG.trackEndpoint) return Promise.resolve(null);
    extra = extra || {};
    var body = {
      event: event,
      anon_id: anonId(),
      quiz_variant: variant,
      last_step: extra.last_step != null ? extra.last_step : step
    };
    if (extra.recommendation) body.recommendation = extra.recommendation;
    if (extra.email || answers.__email) body.email = extra.email || answers.__email;
    try {
      return fetch(CFG.trackEndpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
        keepalive: true,
        mode: 'cors'
      }).then(function (r) {
        if (!r.ok || r.status === 204) return null;
        return r.json().catch(function () { return null; });
      }).catch(function () { return null; });
    } catch (e) { return Promise.resolve(null); }
  }

  // Wait for the track response briefly; Klaviyo calls must not hang on Vercel.
  function withTimeout(p, ms) {
    return new Promise(function (resolve) {
      var t = setTimeout(function () { resolve(null); }, ms);
      p.then(function (v) { clearTimeout(t); resolve(v); }, function () { clearTimeout(t); resolve(null); });
    });
  }

  // Klaviyo events are identified only. Never send anonymous_id-only payloads —
  // that creates billable profiles with no email.
  function profileIdentifiers(email) {
    var attrs = {};
    var e = email || answers.__email;
    if (e) attrs.email = e;
    var kx = klaviyoKx();
    if (kx) attrs._kx = kx;
    return attrs;
  }

  function klaviyoKx() {
    try {
      var m = document.cookie.match(/(?:^|;\s*)__kla_id=([^;]*)/);
      if (!m) return '';
      var raw = decodeURIComponent(m[1]);
      var data;
      try { data = JSON.parse(atob(raw)); }
      catch (e1) { data = JSON.parse(raw); }
      return data.$exchange_id || data.exchange_id || '';
    } catch (e) {
      return '';
    }
  }

  function identifyKlaviyo(email) {
    try {
      var k = window.klaviyo;
      if (k && typeof k.identify === 'function') k.identify({ email: email });
    } catch (e) { /* klaviyo.js optional */ }
  }

  function track(metric, extra) {
    if (CFG.klaviyoPublicKey === 'PUBLIC_API_KEY') return Promise.resolve();
    if (!answers.__email) return Promise.resolve();
    var attrs = Object.assign({ quiz_variant: variant }, answers, extra || {});
    delete attrs.__email;
    return kl('events', {
      data: { type:'event', attributes: {
        properties: attrs,
        metric: { data: { type:'metric', attributes: { name: metric } } },
        profile: { data: { type: 'profile', attributes: profileIdentifiers() } }
      }}
    }).catch(function (err) {
      if (typeof console !== 'undefined' && console.warn) console.warn(err);
    });
  }

  function subscribe(email) {
    // With revision 2024-10-15, nested profile.subscriptions is rejected.
    // Omitting it defaults the channel to email marketing and adds to the list.
    return kl('subscriptions', {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Collage Beauty Quiz',
          profile: {
            data: {
              type: 'profile',
              attributes: profileAttrs(email)
            }
          }
        },
        relationships: {
          list: { data: { type: 'list', id: CFG.klaviyoListId } }
        }
      }
    });
  }

  function submit(email) {
    answers.__email = email;
    result = resolve(answers);
    var rec = CFG.products[result.primary].handle;

    // Log the submit first; the response carries the client IP so it can be
    // attached to the Klaviyo profile. Capped at 1.5s so Klaviyo never waits
    // on Vercel if it is slow or down.
    return withTimeout(funnelTrack('submitted', { recommendation: rec }), 1500).then(function (r) {
      if (r && typeof r.ip === 'string') submitIp = r.ip;

      if (CFG.klaviyoPublicKey === 'PUBLIC_API_KEY') {
        store.set(K_DONE, '1');
        return fetchCode(email);
      }

      identifyKlaviyo(email);

      // Klaviyo Completed Quiz is identified (email). Do not wait on upsert —
      // a profiles API failure must not hide that the quiz finished.
      var completedExtra = { recommendation: rec };
      if (submitIp) completedExtra.quiz_submit_ip = submitIp;
      var completed = track('Completed Quiz', completedExtra);

      return kl('profiles', {
        data: { type: 'profile', attributes: profileAttrs(email) }
      })
      .then(function () {
        return subscribe(email).catch(function (err) {
          if (typeof console !== 'undefined' && console.warn) console.warn(err);
        });
      })
      .catch(function (err) {
        if (typeof console !== 'undefined' && console.warn) console.warn(err);
      })
      .then(function () {
        return completed;
      })
      .then(function () {
        store.set(K_DONE, '1');
        store.set('cb_subscribed', '1');
        return fetchCode(email);
      });
    });
  }

  function fetchCode(email) {
    if (!CFG.codeEndpoint) { code = CFG.staticCode; return Promise.resolve(); }
    return fetch(CFG.codeEndpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: email })
    })
    .then(function (r) { return r.json(); })
    .then(function (d) { code = d.code || CFG.staticCode; })
    .catch(function () { code = CFG.staticCode; });
  }

  /* ------------------------------------------------------------------
     OPEN / CLOSE
  ------------------------------------------------------------------ */
  var viewedFired = false;
  var leftFired = false;

  function markLeft() {
    if (leftFired) return;
    if (!scrim || !scrim.classList.contains('cb-open')) return;
    leftFired = true;
    if (step === 0) funnelTrack('dismissed');
    else if (step > 0 && step < 5) funnelTrack('abandoned');
  }

  function dismiss() {
    if (isEmbed()) return; // no dismiss chrome in embed
    markLeft();
    store.set(K_DISMISS, String(Date.now()));
    close();
  }

  function open() {
    if (scrim.classList.contains('cb-open')) return;
    var resolved = activeVariant();
    if (resolved !== variant) applyVariant(resolved);
    else scrim.setAttribute('data-variant', variant);
    lastFocus = document.activeElement;
    scrim.classList.add('cb-open');
    if (!isEmbed()) document.body.style.overflow = 'hidden';
    scheduleCloseBtn();
    if (!pane.querySelector('.cb-pane__inner')) renderTeaser();
    if (!viewedFired) {
      viewedFired = true;
      funnelTrack('viewed');
    }
  }

  function close() {
    if (isEmbed()) return; // stay mounted and visible
    if (closeTimer) clearTimeout(closeTimer);
    if (closeBtn) {
      closeBtn.classList.remove('cb-close-show');
      closeBtn.setAttribute('tabindex', '-1');
    }
    scrim.classList.remove('cb-open');
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  // Resolves true when Klaviyo's onsite JS recognises this visitor as an
  // existing profile (identified via form fill, email click-through, etc.).
  // Resolves false for anonymous visitors, or when klaviyo.js never turns up
  // within identifyCheckWaitMs — the quiz fails open rather than staying shut.
  function klaviyoIdentified() {
    return new Promise(function (resolve) {
      if (!CFG.skipIdentified) return resolve(false);
      var settled = false;
      function done(v) { if (!settled) { settled = true; resolve(!!v); } }
      var waited = 0;
      (function poll() {
        var k = window.klaviyo;
        if (k && typeof k.isIdentified === 'function') {
          try {
            var r = k.isIdentified();
            if (r && typeof r.then === 'function') r.then(done, function () { done(false); });
            else done(r);
          } catch (e) { done(false); }
          return;
        }
        waited += 200;
        if (waited >= CFG.identifyCheckWaitMs) return done(false);
        setTimeout(poll, 200);
      })();
      // Backstop in case isIdentified() itself never settles.
      setTimeout(function () { done(false); }, CFG.identifyCheckWaitMs + 2000);
    });
  }

  function arm() {
    if (suppressed()) return;
    var identified = klaviyoIdentified();
    var fired = false;
    function go() {
      if (fired) return;
      fired = true;
      window.removeEventListener('scroll', onScroll);
      identified.then(function (known) { if (!known) open(); });
    }
    function onScroll() {
      var h = document.documentElement.scrollHeight - window.innerHeight;
      if (h > 0 && (window.scrollY / h) * 100 >= CFG.scrollPct) go();
    }
    setTimeout(go, CFG.delayMs);
    if (CFG.scrollPct > 0) window.addEventListener('scroll', onScroll, { passive: true });
  }

  function reset() {
    store.del(K_DISMISS); store.del(K_DONE); store.del('cb_subscribed');
    answers = {}; result = null; code = null; step = 0; submitIp = null;
    currentStepRender = null;
    viewedFired = false;
    leftFired = false;
    if (pane) pane.innerHTML = '';
  }

  function setVariant(v) {
    CFG.forceVariant = v === 'desktop' || v === 'mobile' ? v : 'auto';
    applyVariant();
  }

  function pathAllowed() {
    if (!CFG.onlyPaths || !CFG.onlyPaths.length) return true;
    var path = (location.pathname || '/').replace(/\/+$/, '') || '/';
    for (var i = 0; i < CFG.onlyPaths.length; i++) {
      var allowed = String(CFG.onlyPaths[i]).replace(/\/+$/, '') || '/';
      if (path === allowed) return true;
    }
    return false;
  }

  function init() {
    if (!pathAllowed()) return;
    injectStyles();
    if (!build()) return;

    if (isEmbed()) {
      // Inline page: always show, skip popup delay / suppression / identify gate
      open();
      centerEmbed();
      // Re-center after fonts/images settle layout
      setTimeout(centerEmbed, 50);
      setTimeout(centerEmbed, 300);
    } else {
      arm();
    }

    window.addEventListener('pagehide', function (e) {
      if (e.persisted) return;
      markLeft();
    });
    window.CollageQuiz = {
      __booted: true,
      open: open,
      close: close,
      reset: reset,
      setVariant: setVariant,
      getVariant: function () { return variant; },
      config: CFG,
      preview: function (a) {
        answers = Object.assign({}, a);
        result = resolve(answers);
        code = CFG.staticCode;
        viewedFired = true; // demo open — keep it out of the Viewed Quiz metric
        open();
        renderResults();
      }
    };
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
